import React from 'react';
import styled from 'styled-components';
import { Content } from "../../components/Layout";
import { Flex } from '../../components/Flex';
import { Paragraph, Title } from '../../components/Text';
import { OrgsIcon } from '../../icons/OrgsIcon';
import { IconButton } from '../../icons/IconContainer';
import { UsersIcon } from '../../icons/UsersIcon';
import { IssuesIcon } from '../../icons/IssuesIcon';
import { PackagesIcon } from '../../icons/PackagesIcon';

const DashboardBox = styled(Flex).attrs({
    background: "#FFFFFF",
    align: 'center',
    gap: { right: 20 },
    height: "80px"
})`
    border-radius: 16px;
    padding: 0px 32px;
    cursor: pointer;
    flex: 1 0 240px;
    text-transform: capitalize;
`;

export const DashboardItem = ({ icon, title, onClick }) => (
    <DashboardBox onClick={onClick}>
        {icon && <IconButton
            background="#6092E2"
        >
            {icon}
        </IconButton>}
        <Paragraph size="18px" lineHeight="20px" color="#1C62D2" bold>{title}</Paragraph>
    </DashboardBox>
)

const actions = [
    {
        key: "organisations",
        title: "Add Organisation",
        icon: <OrgsIcon />
    },
    {
        key: "users",
        title: "Add User",
        icon: <UsersIcon />
    },
    {
        key: "issues",
        title: "Add Issue",
        icon: <IssuesIcon />
    },
    {
        key: "packages",
        title: "Add Package",
        icon: <PackagesIcon />
    }
];
const Dashboard = ({ showForm }) => {

    return(
        <Content gap={{ bottom: 28 }}>
            <Title h3>Quick actions</Title>
            <Flex gap={{ right: 32 }} >
                {actions.map((action, idx) =>
                    <DashboardItem
                        key={`action-${idx}`}
                        onClick={() => showForm(action.key)}
                        icon={action.icon}
                        title={action.title}
                    />
                )}
            </Flex>
        </Content>
    );
};

export { Dashboard };